/* global document, Office */

export function applyTheme(): void {
  const theme = (Office.context as any).officeTheme;
  const root = document.documentElement;
  const bg = theme?.bodyBackgroundColor ?? null;
  const accent = theme?.themePrimary ?? null;
  const dark = bg ? getLuminance(bg) < 0.15 : false;

  if (dark) {
    root.style.setProperty("--bg", bg ?? "#1b1a19");
    root.style.setProperty("--bg-subtle", "#292827");
    root.style.setProperty("--bg-card", "#252423");
    root.style.setProperty("--border", "#3b3a39");
    root.style.setProperty("--border-subtle", "#323130");
    root.style.setProperty("--text", "#f3f2f1");
    root.style.setProperty("--text-muted", "#c8c6c4");
    root.style.setProperty("--text-faint", "#a19f9d");
    root.style.setProperty("--accent", accent ?? "#479ef5");
    root.style.setProperty("--accent-subtle", "#1f3a5c");
    root.style.setProperty("--input-bg", "#323130");
    root.style.setProperty("--input-border", "#484644");
    root.style.setProperty("--status-pending-bg", "#3d3115");
    root.style.setProperty("--status-pending-fg", "#fce100");
    root.style.setProperty("--status-mapped-bg", "#1a3a1a");
    root.style.setProperty("--status-mapped-fg", "#6ccb6c");
    root.style.setProperty("--status-unmapped-bg", "#3d1515");
    root.style.setProperty("--status-unmapped-fg", "#f1707b");
  } else {
    root.style.setProperty("--bg", bg ?? "#ffffff");
    root.style.setProperty("--bg-subtle", "#f3f2f1");
    root.style.setProperty("--bg-card", "#faf9f8");
    root.style.setProperty("--border", "#e1dfdd");
    root.style.setProperty("--border-subtle", "#edebe9");
    root.style.setProperty("--text", "#201f1e");
    root.style.setProperty("--text-muted", "#484644");
    root.style.setProperty("--text-faint", "#605e5c");
    root.style.setProperty("--accent", accent ?? "#0078d4");
    root.style.setProperty("--accent-subtle", "#deecf9");
    root.style.setProperty("--input-bg", "#ffffff");
    root.style.setProperty("--input-border", "#8a8886");
    root.style.setProperty("--status-pending-bg", "#fff4ce");
    root.style.setProperty("--status-pending-fg", "#7a6400");
    root.style.setProperty("--status-mapped-bg", "#dff6dd");
    root.style.setProperty("--status-mapped-fg", "#0e6b0e");
    root.style.setProperty("--status-unmapped-bg", "#fde7e9");
    root.style.setProperty("--status-unmapped-fg", "#a80000");
  }
}

function getLuminance(hex: string): number {
  const c = hex.replace("#", "");
  const r = parseInt(c.substring(0, 2), 16) / 255;
  const g = parseInt(c.substring(2, 4), 16) / 255;
  const b = parseInt(c.substring(4, 6), 16) / 255;
  const linearize = (v: number) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
  return 0.2126 * linearize(r) + 0.7152 * linearize(g) + 0.0722 * linearize(b);
}
